export default __webpack_public_path__ + "c4.png";